const memberDetails = (state = null, action) => {
  if (action.type === "SET_MEMBER_DETAILS") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_MEMBER_DETAILS": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default memberDetails;
